"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTopics = fetchTopics;
exports.getBugStatuses = getBugStatuses;
exports.getIdeaStatuses = getIdeaStatuses;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getIdeaStatuses() {
  return _getIdeaStatuses.apply(this, arguments);
}

function _getIdeaStatuses() {
  _getIdeaStatuses = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var _yield$axios$get, data;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.get('/community/api/ideas/ideaStatuses');

          case 2:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            return _context.abrupt("return", data.result);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getIdeaStatuses.apply(this, arguments);
}

function getBugStatuses() {
  return _getBugStatuses.apply(this, arguments);
}

function _getBugStatuses() {
  _getBugStatuses = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var _yield$axios$get2, data;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.get('/community/api/contentStatuses', {
              params: {
                context: 'bug'
              }
            });

          case 2:
            _yield$axios$get2 = _context2.sent;
            data = _yield$axios$get2.data;
            return _context2.abrupt("return", data.map(function (status) {
              return {
                id: String(status.id),
                name: status.name,
                backgroundColor: status.backgroundColor,
                textColor: status.textColor
              };
            }));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getBugStatuses.apply(this, arguments);
}

function fetchTopics(_x, _x2) {
  return _fetchTopics.apply(this, arguments);
}

function _fetchTopics() {
  _fetchTopics = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(requestUrl, query) {
    var stripHtmlFromContent,
        trimContentLength,
        enableLanguageBasedCategoryFilter,
        requestBody,
        _yield$axios$post,
        data,
        topics,
        total,
        authors,
        _args3 = arguments;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            stripHtmlFromContent = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : false;
            trimContentLength = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : 0;
            enableLanguageBasedCategoryFilter = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : false;
            requestBody = _objectSpread(_objectSpread({}, query), {}, {
              stripHtmlFromContent: stripHtmlFromContent,
              trimContentLength: trimContentLength,
              enableLanguageBasedCategoryFilter: enableLanguageBasedCategoryFilter
            });
            _context3.next = 6;
            return _axios.default.post(requestUrl, requestBody);

          case 6:
            _yield$axios$post = _context3.sent;
            data = _yield$axios$post.data;
            topics = data.topics, total = data.total, authors = data.authors;
            return _context3.abrupt("return", {
              topics: topics,
              total: total,
              authors: authors
            });

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchTopics.apply(this, arguments);
}